import { createTheme } from "@mui/material/styles";

const brand = {
  purple400: "#262A56",
  purple300: "#5155D5",
  purple200: "#8A94F3",
  purple100: "#E2E2FA",
  yellow100: "#FFF050",
  gray100: "#F2F2F2",
  gray200: "#CCCCCC",
  gray300: "#616161",
  gray400: "#323232",
};

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: brand.purple400,
      light: brand.purple200,
      dark: "#1B1F45",
    },
    secondary: {
      main: brand.purple300,
      light: brand.purple200,
      dark: "#3E41AF",
    },
    warning: {
      main: brand.yellow100,
    },
    background: {
      default: "#F7F8FD",
      paper: "#FFFFFF",
    },
    text: {
      primary: brand.gray400,
      secondary: brand.gray300,
    },
    divider: brand.gray200,
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: "'DM Sans', 'Arial', sans-serif",
    h1: {
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontWeight: 600,
      letterSpacing: "-0.015em",
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 600,
    },
    overline: {
      fontFamily: "'DM Mono', 'DM Sans', monospace",
      letterSpacing: "0.08em",
    },
    button: {
      fontFamily: "'DM Mono', 'DM Sans', monospace",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          paddingInline: 16,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "0 12px 30px rgba(38, 42, 86, 0.08)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#FFFFFF",
          borderLeft: `1px solid ${brand.gray100}`,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
        },
        notchedOutline: {
          borderColor: brand.gray200,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          margin: "4px 10px",
          padding: "10px 14px",
          transition: "background 200ms ease, color 200ms ease",
          "&:hover": {
            backgroundColor: "rgba(226, 226, 250, 0.65)",
            color: brand.purple400,
          },
          "&.Mui-selected": {
            backgroundColor: "rgba(226, 226, 250, 0.9)",
            color: brand.purple400,
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 32,
          color: brand.purple300,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: "0.95rem",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderRadius: 3,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
  },
});

export default theme;
